<template>
    <div>
      <ZwiflocTabs :tabList="tabList">

        <template v-slot:tabPanel-2>
             <div class="zwifloc-products" v-zwiflocproducts @click='carouselfunc'>
                <div class="container">
                <p id="productsLen" style="display:none;">{{products.length}}</p>
                <p id = 'pc1' class='product-counter'>PRODUCTS ( {{productPageCount}} - {{products.length}} OF {{products.length}})</p>
                <template v-for="(products, pc_index) in productsChunk">
                    <div class="row product-row" :style="pc_index > 0 ? 'display:none' : ''" :key="pc_index">
                        <template v-for="(product,product_index) in products" >
                            <div :class="chunk == 6 ? 'col-lg-4' : 'col-lg-2'" :key="product_index">
                            <div class="card">
                            <div class="top">
                                <a class="productsLink" :href="'/product/'+ product.stockCode">
                                <div class="card-image"
                                    :style="{ backgroundImage: 'url(' + product.defaultImage + ')' }" style="background-size:100%">
                                </div>
                                </a>
                                 <div class="__new-product" v-if= "product.newProductExpiryDate >= current_date  && userType == 'B2B'"> <p> New </p> </div>
                                <div>
                                    <a class="productsLink" :href="'/product/'+ product.stockCode">
                                    <p class="title" ><span v-html="product.title"></span></p>
                                    <p id='product_stockcode' class="stockCode">{{product.stockCode}}</p>
                                    </a>
                                </div>
                            </div>
                            <!-- <div class="bottom">
                                <a target="_blank" :href="product.stockCode" class="btn btn-hover btn-cart btn-primary">View Product</a>
                            </div> -->
                            </div>
                            </div>
                        </template>
                    </div>
                </template>
            <div>

            <template>
            <ul class="controls"  v-show="productsChunk.length > 1">
                <li data-type="pr_prev"></li>
                 <!-- <template > -->
                    <li data-type="pr_step" v-for="(pc, key_index) in productsChunk" :class="key_index<1? 'active': '' " :key="key_index"></li>
                <!-- </template> -->
                <li data-type="pr_next"></li>
            </ul>
        </template>
        </div>

        </div>
             </div>
        </template>

        <template v-slot:tabPanel-1 >
            <div class="zwifloc-products next-one" v-zwiflocincluded @click='carouselnextfunc'>
                <div class="container">
                <p id="zwilocLen" style="display:none;">{{zwifloc.length}}</p>
                <p id = 'zc1' class='zwifloc-counter'>PRODUCTS ( {{productPageCount}} - {{zwifloc.length}} OF {{zwifloc.length}})</p>
                <template v-for="(zwifloc_included, zw_index) in zwiflocChunk">
                    <div class="row zwifloc-row" :style="zw_index > 0 ? 'display:none' : ''" :key="zw_index">
                        <template v-for="(zwifloc,zwifloc_index) in zwifloc_included" >
                            <div :class="chunk == 6 ? 'col-lg-4' : 'col-lg-2'" :key="zwifloc_index">
                            <div class="card">
                            <div class="top">
                                <a class="productsLink" :href="'/product/'+ zwifloc.stockCode">
                                <div class="card-image"
                                    :style="{ backgroundImage: 'url(' + zwifloc.defaultImage + ')' }" style="background-size:100%">
                                </div>
                                </a>
                                    <div class="__new-product" v-if= "zwifloc.newProductExpiryDate >= current_date && userType == 'B2B'"> <p> New </p> </div>
                                <div>
                                    <a class="productsLink" :href="'/product/'+ zwifloc.stockCode">
                                    <p class="title" ><span v-html="zwifloc.title"></span></p>
                                    <p class="stockCode">{{zwifloc.stockCode}}</p>
                                    </a>
                                </div>
                            </div>
                            <!-- <div class="bottom">
                                <a target="_blank" :href="product.stockCode" class="btn btn-hover btn-cart btn-primary">View Product</a>
                            </div> -->
                            </div>
                            </div>
                        </template>
                    </div>
                </template>
            <div>

            <template >
            <ul v-show="zwiflocChunk.length > 1" class="controls">
                <li data-type="prev"></li>
                 <!-- <template > -->
                    <li data-type="step" v-for="(zw, index) in zwiflocChunk" :class="index<1? 'active': '' " :key="index"></li>
                <!-- </template> -->
                <li data-type="next" ></li>
            </ul>
        </template>
        </div>

        </div>
             </div>
        </template>
      </ZwiflocTabs>
    </div>
  </template>

<script>
    import Axios from 'axios';
    import ZwiflocTabs from "./ZwiflocTabs";

        export default {

            components: {
                ZwiflocTabs,
            },
            data() {
                return{
                    productPageCount: 1,
                    chunk: 6,
                    products: [],
                    zwifloc: [],
                    productsChunk:[],
                    zwiflocChunk:[],
                    tabList: ["ZWIFLOC INCLUDED", "COMPATIBLE PRODUCTS"],
                    userType: 'B2C',
                    current_date: '',
                };
            },
            mounted() {
                this.getCurrentDate();
                this.isB2bUser();
                this.loadProducts();

            },
            methods: {
                getCurrentDate(){
                    const current = new Date();
                    this.current_date = `${current.getFullYear()}-${current.getMonth()+1}-${current.getDate()}`
                },
                isB2bUser() {;
                     this.userType = this.$store.getters["auth/userType"]; 
                    },    
                loadProducts: function(){
                    Axios
                    .get("/getProducts")
                    .then((response) => {
                        this.products = response.data[0];
                        this.zwifloc = response.data[1];
                        this.chunkArr(this.products, 6);
                        this.chunkZwifloc(this.zwifloc,6);
                    })
                    .catch(function(error){
                        console.log(error);
                    });

                },
                chunkArr(arr, chunkSize) {
                if (chunkSize <= 0) throw "Invalid chunk size";
                for (var i=0,len=arr.length; i<len; i+=chunkSize)
                    this.productsChunk.push(arr.slice(i,i+chunkSize));
                return this.productsChunk;
                },
                chunkZwifloc(arr, chunkSize) {
                if (chunkSize <= 0) throw "Invalid chunk size";
                for (var i=0,len=arr.length; i<len; i+=chunkSize)
                    this.zwiflocChunk.push(arr.slice(i,i+chunkSize));
                return this.zwiflocChunk;
                },
                carouselfunc(){
                    document.dispatchEvent(new CustomEvent("renderProductPagination"));
                },
                carouselnextfunc(){
                    document.dispatchEvent(new CustomEvent("renderIncludedProductPagination"));
                }
            },
            
            
        }

</script>
<style lang="scss" scoped>

.zwifloc-products {
    min-height: 500px;
    background-color: white;

    .container {
        padding-top: 4rem;
        padding-bottom: 4rem;

        .product-counter, .zwifloc-counter{
            height: 28px;
            width: 100%;
            color: #0F1720;
            font-family: trim-regular;
            font-size: 16px;
            font-weight: 700;
            letter-spacing: 0.31px;
            line-height: 19px;
        }


        .title {
            font-size: 1.5rem;
            text-transform: uppercase;
            font-family: 'trim-regular';
            text-align: left;
        }

        .description {
            text-align: center;
            color: #A4A4A4;
            font-family: 'trim-regular';
        }

        .col-lg-6,
        .col-lg-4,
        .col-lg-2 {
            margin-bottom: 3rem;

            @media screen and (max-width: 991px) {
                flex: 0 0 50%;
            }
        }

        ul.controls {
            display: flex;
            justify-content: center;
            align-items: center;
            margin-top: 2rem;
            padding-left: 0;

            li {
                list-style-type: none;
                height: .8rem;
                width: .8rem;
                background-color: #D8D8D8;
                margin: .4rem;
                cursor: pointer;

                &.active {
                    background-color: #005CB9;
                }

                &:first-child {
                    background-color: transparent;
                    border: solid #353535;
                    border-width: 0 3px 3px 0;
                    display: inline-block;
                    width: 1rem;
                    height: 1rem;
                    transform: rotate(135deg);
                    margin-right: 1rem;
                }

                &:last-child {
                    background-color: transparent;
                    border: solid #353535;
                    border-width: 0 3px 3px 0;
                    display: inline-block;
                    width: 1rem;
                    height: 1rem;
                    transform: rotate(-45deg);
                    margin-left: 1rem;
                }
            }
        }
    }

    .productsLink{
        text-decoration: none;
        color: #000000;
    }

    .card {
        background-color: white;
        box-shadow: 0 4px 30px 4px rgb(0 0 0 / 5%);
        transition: 0.3s;
        min-height: 1rem;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        @media screen and (max-width: 992px) {
            min-height: 1rem;
            margin-bottom: 1rem;
        }   

        p {
            padding-left: 1rem;
            padding-right: 1rem;
            &.title {
                font-family: 'trim-medium';
                font-size: 1.1rem;
                text-transform: uppercase;

                @media screen and (max-width: 500px) {
                    padding-top: 0;
                    font-size: 14px;
                    }
            }
            &.stockCode{
                font-family: 'trim-regular';
                font-size: 17px;
                @media screen and (max-width: 500px) {
                    font-size: 14px;
                }
            }
        }

        .card-image {
            width: 100%;
            height: 15rem;
            background-repeat: no-repeat;
            background-size: cover;
            background-position: center;
            background-position-y: top;
            overflow: hidden;

            @media screen and (max-width: 1199px) {
                height: 12rem;
            }
            @media screen and (max-width: 767px) {
                height: 10rem;
            }
            @media screen and (max-width: 500px) {
                height: 9rem;
            }
            @media screen and (max-width: 450px) {
                height: 8rem;
            }

        }
        .bottom {
            margin: 0 1rem 0 1rem;
            a {
                text-align: center;
            }
        }
    }
    .view-all {
        display: flex;
        justify-content:center;
        align-items:center;
        a {
            margin-top:1rem;
            padding: 1rem 2rem 1rem 2rem;
            color:white;
            background-color: #005DB9;
            text-transform: uppercase;
            text-decoration: none;
        }
    }
}


    .__new-product{

        @media screen and (max-width: 967px)  {
            top: 0px;
            right: 15px;
        }

        @media screen and (max-width: 500px) {
            width: 83px;
        }

        position: absolute;
        top: 0px;
        right: 15px;
        height: 100px;
        width: 100px;
        z-index: 1;

        &::before {
            content: '';
            display: block;
            position: absolute;
            z-index: 0;
            top: 0;
            right: 0;
            width: 0;
            height: 0;
            border: 50px solid transparent;
            border-top-color: #005cb9;
            border-right-color: #005cb9;

            @media screen and (max-width: 500px) {
                border: 43px solid transparent;
                border-top-color: #005cb9;
                border-right-color: #005cb9;
            }
        }
        p {
            -webkit-transform-origin: 21px 36px;
            transform-origin: 21px 36px;
            -webkit-transform: rotate(45deg);
            transform: rotate(45deg);
            color: #fff;
            text-transform: uppercase;
            font-family: "trim-medium";
            position: relative;
            z-index: 1;
            width: 100px;
            text-align: center;

            @media screen and (max-width: 500px) {
                padding-left: 0 !important;
            }
        }
    }


</style>